
import Nav from 'react-bootstrap/Nav';
import { INavBarItem } from '../../../types/menu';

import NavItemComponent from "./NavItemComponent";

function MenuComponent({items}:any) {
  return (
    <div className="nav-body d-lg-block d-none">
        <div className="container-fluid">
          <div className="nav-bodyInner">
          <Nav className="nav justify-content-center" as="ul">
            {items.map((item: INavBarItem, index: number) => (
              <NavItemComponent key={index} {...item}  />
            ))}
          </Nav>
          
          </div>
        </div>
      </div>
  );
}

export default MenuComponent;


